// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__3Em2c","marketplaceStroke":"IconEmailAttention_marketplaceStroke__3M2rQ","attentionStroke":"IconEmailAttention_attentionStroke__CWfyf"};